import NiotaClassicApiService from '@/services/niotaClassicApiService';
import { mapState } from 'vuex';
import dataSourcesDataMixin from './dataSourcesDataMixin';
import { nanoid } from 'nanoid';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
export default {
  name: 'NiotaClassicOriginatorsForm',
  components: {
    MarkdownItVueLight
  },
  mixins: [formMixin, dataSourcesDataMixin],
  props: {
    editedItem: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      accounts: [],
      datasources: [],
      showActilityPassword: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    originatorFormButtons() {
      if (this.formItem.id) {
        return this.formCardButtons;
      }
      return [{
        icon: 'fal fa-arrow-left',
        action: 'back',
        tooltip: this.$i18n_t('Common.reset')
      }].concat(this.formCardButtons);
    },
    dataSourcesForType() {
      return this.datasources.filter(ds => {
        if (this.formItem.type === 'Webhook') {
          return ds.type === 'webhook';
        } else if (this.formItem.type === 'auto_id') {
          return ds.type === 'auto_id';
        } else if (this.formItem.type === 'Filesystem') {
          return ds.type === 'filesystem';
        }
        return ['webhook', 'auto_id', 'filesystem'].indexOf(ds.type) < 0;
      });
    },
    datasourceTypes() {
      return [{
        type: 'LoRaWAN',
        fields: {
          user: {
            help: this.$i18n_t('NiotaClassic.Originators.form.credentials_lorawan_text'),
            requiredRule: [v => this.selectedDatasourceType.startsWith('firefly') || !!v || this.$i18n_t('Common.fieldRequired')]
          },
          password: {
            help: this.$i18n_t('NiotaClassic.Originators.form.credentials_lorawan_text'),
            requiredRule: [v => this.selectedDatasourceType.startsWith('firefly') || !!v || this.$i18n_t('Common.fieldRequired')]
          },
          apiKey: {
            help: this.$i18n_t('NiotaClassic.Originators.form.apikey_firefly_text'),
            requiredRule: [v => !this.selectedDatasourceType.startsWith('firefly') || !!v || this.$i18n_t('Common.fieldRequired')]
          }
        }
      }, {
        type: 'Sigfox',
        fields: {
          user: {
            help: this.$i18n_t('NiotaClassic.Originators.form.user_sigfox_text'),
            requiredRule: this.requiredRule
          },
          password: {
            help: this.$i18n_t('NiotaClassic.Originators.form.password_sigfox_text'),
            requiredRule: this.requiredRule
          },
          apiKey: {
            help: this.$i18n_t('NiotaClassic.Originators.form.apikey_sigfox_text'),
            requiredRule: this.requiredRule
          }
        }
      }, {
        type: 'NB-IoT',
        fields: {
          apiKey: {
            help: this.$i18n_t('NiotaClassic.Originators.form.apikey_nbiot_text'),
            requiredRule: this.requiredRule
          }
        }
      }, {
        type: 'Discovergy',
        fields: {
          user: {
            help: this.$i18n_t('NiotaClassic.Originators.form.user_discovergy_text'),
            requiredRule: this.requiredRule
          },
          password: {
            help: this.$i18n_t('NiotaClassic.Originators.form.password_discovergy_text'),
            requiredRule: this.requiredRule
          },
          polling_interval: {
            help: this.$i18n_t('NiotaClassic.Originators.form.polling_intervall_text'),
            requiredRule: this.requiredRule
          }
        }
      }, {
        type: 'Temetra',
        fields: {
          apiKey: {
            help: this.$i18n_t('NiotaClassic.Originators.form.apikey_firefly_text'),
            requiredRule: this.requiredRule
          },
          temetra_api_key: {
            help: this.$i18n_t('NiotaClassic.Originators.form.apikey_temetra_text'),
            requiredRule: this.requiredRule
          }
        }
      }, {
        type: 'Actility',
        fields: {
          target_profile: {
            requiredRule: this.requiredRule
          },
          act_login: {
            requiredRule: this.requiredRule
          },
          act_password: {
            requiredRule: this.requiredRule
          }
        }
      }, {
        type: 'Filesystem',
        fields: {
          formate: {
            help: this.$i18n_t('NiotaClassic.Originators.form.formate_text'),
            requiredRule: this.requiredRule
          },
          import_path: {
            help: this.$i18n_t('NiotaClassic.Originators.form.import_path_text'),
            requiredRule: this.requiredRule
          },
          polling_interval: {
            help: this.$i18n_t('NiotaClassic.Originators.form.polling_intervall_text'),
            requiredRule: this.requiredRule
          },
          xslt: {
            help: this.$i18n_t('NiotaClassic.Originators.form.xslt_text'),
            requiredRule: this.requiredRule
          }
        }
      }, {
        type: 'Webhook',
        fields: {
          import_api_key: {
            requiredRule: this.requiredRule
          },
          transform_template: {}
        }
      }, {
        type: 'auto_id',
        fields: {
          import_api_key: {
            requiredRule: this.requiredRule
          }
        }
      }];
    },
    selectedOriginatorType() {
      return (this.dataSourcesData[this.formItem.type] || {}).name || this.formItem.type;
    },
    selectedDatasourceType() {
      return (this.formItem.datasource || {}).type || '';
    },
    formConfig() {
      if (!this.formItem.type) {
        return {};
      }
      // if (this.$refs.form) {
      //   // re-run validation if data-source changes
      //   this.$refs.form.validate();
      // }
      return (this.datasourceTypes.find(config => config.type === this.formItem.type) || {}).fields || {};
    },
    webhookApiPath() {
      const endpoint = this.editedItem.type === 'Webhook' ? 'packets' : 'auto-id-events';
      return `${this.n1Protocol}://${this.n1Host}/api/x/webhooks/originators/${this.formItem.id || ':originator_id'}/${endpoint}?auth=${this.formItem.options.import_api_key}`;
    }
  },
  watch: {},
  created() {
    this.formItem = cloneDeep(this.editedItem);
    if (!this.formItem.options) {
      this.formItem.options = {
        formate: 'xml'
      };
    }
    this.formItem.account = this.formItem.account || {};
    // workaround to make the account-name being displayed from the beginning
    // it comes returned as "name1" within the object, but it is just "name" in the `accounts` list
    this.formItem.account.name = this.formItem.account.name || this.formItem.account.name1;
    this.formItem.options.import_api_key = this.formItem.options.import_api_key || nanoid(32);
    NiotaClassicApiService.accountsFetchPlain().then(res => {
      this.accounts = res.data.accounts;
    }).catch(() => {
      this.$snack(this.$i18n_t('Common.errorFetchingAccounts'), 'error');
    });
    NiotaClassicApiService.dataSourcesFetchPlain().then(res => {
      this.datasources = res.data.datasources;
    }).catch(() => {
      this.$snack(this.$i18n_t('Common.errorFetchingDatasources'), 'error');
    });
  },
  methods: {
    handleDataSourceChange() {
      if (this.$refs.form) {
        // re-run validation if data-source changes
        this.$refs.form.validate();
      }
    },
    copyToClipboard(refId) {
      let element = this.$refs[refId];
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(element.innerHTML);
      } else {
        var range;
        if (document.selection) {
          // IE
          range = document.body.createTextRange();
          range.moveToElementText(element);
          range.select();
        } else if (window.getSelection) {
          range = document.createRange();
          range.selectNode(element);
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(range);
        }
        document.execCommand('copy');
        if (document.selection) {
          document.selection.empty();
        } else {
          window.getSelection().removeAllRanges();
        }
      }
    },
    updateRequest() {
      this.formItem.accountId = (this.formItem.account || {}).id;
      this.formItem.datasourceId = (this.formItem.datasource || {}).id;
      return NiotaClassicApiService.originatorsUpdate(this.formItem.id, this.formItem);
    },
    createRequest() {
      this.formItem.accountId = (this.formItem.account || {}).id;
      this.formItem.datasourceId = (this.formItem.datasource || {}).id;
      return NiotaClassicApiService.originatorsCreate(this.formItem);
    },
    uploadImage(image) {
      NiotaClassicApiService.uploadImage(image, 'originator').then(data => {
        this.formItem.image = data.file;
        this.formItem = cloneDeep(this.formItem);
      }).catch(() => {
        this.$snack(this.$i18n_t('Common.imageUploadError'), 'error');
      });
    }
  }
};